export default {
    actions: {},

    mutations: {
        setSearchText(state, foo) {
            state.searchText = foo;
        }
    },

    state() {
        return {
            searchText: ""
        };
    },

    getters: {
        giveSearchText(state) {
            return state.searchText;
        }
    }
};
